"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Views for the delegate ("on behalf of") write tools — create/edit a
 * delegator's report and add expense lines to it. Merged into
 * `concurToolRegistry` by the registry wiring.
 */
export const concurDelegateWriteToolRegistry = {
  concurCreateDelegatorReport: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./delegate-write-views").then(
        ({ ConcurCreateDelegatorReportToolView }) => ({
          default: ConcurCreateDelegatorReportToolView,
        })
      )
    ),
  },
  concurUpdateDelegatorReport: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./delegate-write-views").then(
        ({ ConcurUpdateDelegatorReportToolView }) => ({
          default: ConcurUpdateDelegatorReportToolView,
        })
      )
    ),
  },
  concurUpdateDelegatorExpense: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./delegate-write-views").then(
        ({ ConcurUpdateDelegatorExpenseToolView }) => ({
          default: ConcurUpdateDelegatorExpenseToolView,
        })
      )
    ),
  },
  concurSubmitDelegatorReport: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./delegate-write-views").then(
        ({ ConcurSubmitDelegatorReportToolView }) => ({
          default: ConcurSubmitDelegatorReportToolView,
        })
      )
    ),
  },
  concurAddDelegatorExpense: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./delegate-write-views").then(
        ({ ConcurAddDelegatorExpenseToolView }) => ({
          default: ConcurAddDelegatorExpenseToolView,
        })
      )
    ),
  },
} satisfies ToolUIRegistry;
